export function scrollToId(id) {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(id, { duration: 1.4 });
  else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
}

export function scrollToTop() {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(0, { duration: 1.4 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
}
